// You can write more code here

/* START OF COMPILED CODE */

import ForestTree1 from '@/game/prefabs/World/ForestTree1';
import Mentor2 from '@/game/prefabs/World/Mentors/Mentor2';
import Player from '@/game/prefabs/World/Player';
import Portal from '@/game/prefabs/World/Portal';
import WorldNode from '@/game/prefabs/World/WorldNode';
import TilemapScene from './TilemapScene';
/* START-USER-IMPORTS */
/* END-USER-IMPORTS */

export default class Level8 extends TilemapScene {
  constructor() {
    super('Level8');

    /* START-USER-CTR-CODE */
    // Write your code here.
    /* END-USER-CTR-CODE */
  }

  editorCreate(): void {
    // spring_biome_4
    const spring_biome_4 = this.add.tilemap('spring-biome-4');
    spring_biome_4.addTilesetImage(
      'spring forest wang tiles',
      'spring forest wang tiles',
    );
    spring_biome_4.addTilesetImage('bonus bridge', 'bonus bridge');
    spring_biome_4.addTilesetImage('spring forest', 'spring forest');
    spring_biome_4.addTilesetImage(
      'spring trees 80x112',
      'spring trees 80x112',
    );
    spring_biome_4.addTilesetImage('spring 16x32', 'spring 16x32');
    spring_biome_4.addTilesetImage('collision & alpha', 'collision & alpha');
    spring_biome_4.addTilesetImage(
      'spring water sparkles B',
      'spring water sparkles B',
    );

    // terrain_1
    spring_biome_4.createLayer('terrain', ['spring forest wang tiles'], 0, 0);

    // deco_1
    spring_biome_4.createLayer('deco', ['spring forest'], 0, 0);

    // sparkles__spring_water_sparkles_B__1
    spring_biome_4.createLayer(
      'sparkles (spring water sparkles B)',
      ['spring water sparkles B'],
      0,
      0,
    );

    // bushes__16x32__1
    spring_biome_4.createLayer('bushes (16x32)', ['spring 16x32'], 0, -10);

    // cOLLISION_1
    const cOLLISION_1 = spring_biome_4.createLayer(
      'COLLISION',
      ['collision & alpha'],
      0,
      0,
    )!;
    cOLLISION_1.visible = false;

    // player
    const player = new Player(this, 16, 328);
    this.add.existing(player);

    // forestTree1
    const forestTree1 = new ForestTree1(this, 62, 160, 'spring_trees_sheet', 1);
    this.add.existing(forestTree1);

    // forestTree
    const forestTree = new ForestTree1(this, 184, 80, 'spring_trees_sheet', 1);
    this.add.existing(forestTree);

    // forestTree_1
    const forestTree_1 = new ForestTree1(this, 32, 43, 'spring_trees_sheet', 1);
    this.add.existing(forestTree_1);

    // forestTree_2
    const forestTree_2 = new ForestTree1(
      this,
      396,
      46,
      'spring_trees_sheet',
      1,
    );
    this.add.existing(forestTree_2);

    // forestTree_3
    const forestTree_3 = new ForestTree1(
      this,
      663,
      116,
      'spring_trees_sheet',
      1,
    );
    this.add.existing(forestTree_3);

    // forestTree_4
    const forestTree_4 = new ForestTree1(
      this,
      273,
      223,
      'spring_trees_sheet',
      1,
    );
    this.add.existing(forestTree_4);

    // forestTree_5
    const forestTree_5 = new ForestTree1(this, 7, 492, 'spring_trees_sheet', 1);
    this.add.existing(forestTree_5);

    // forestTree_6
    const forestTree_6 = new ForestTree1(
      this,
      82,
      536,
      'spring_trees_sheet',
      1,
    );
    this.add.existing(forestTree_6);

    // forestTree_7
    const forestTree_7 = new ForestTree1(
      this,
      482,
      521,
      'spring_trees_sheet',
      1,
    );
    this.add.existing(forestTree_7);

    // forestTree_8
    const forestTree_8 = new ForestTree1(
      this,
      746,
      516,
      'spring_trees_sheet',
      1,
    );
    this.add.existing(forestTree_8);

    // forestTree_9
    const forestTree_9 = new ForestTree1(
      this,
      704,
      553,
      'spring_trees_sheet',
      0,
    );
    this.add.existing(forestTree_9);

    // forestTree_10
    const forestTree_10 = new ForestTree1(
      this,
      449,
      481,
      'spring_trees_sheet',
      0,
    );
    this.add.existing(forestTree_10);

    // forestTree_11
    const forestTree_11 = new ForestTree1(
      this,
      27,
      555,
      'spring_trees_sheet',
      0,
    );
    this.add.existing(forestTree_11);

    // forestTree_12
    const forestTree_12 = new ForestTree1(
      this,
      17,
      118,
      'spring_trees_sheet',
      0,
    );
    this.add.existing(forestTree_12);

    // forestTree_13
    const forestTree_13 = new ForestTree1(
      this,
      109,
      67,
      'spring_trees_sheet',
      0,
    );
    this.add.existing(forestTree_13);

    // forestTree_14
    const forestTree_14 = new ForestTree1(
      this,
      275,
      71,
      'spring_trees_sheet',
      0,
    );
    this.add.existing(forestTree_14);

    // forestTree_15
    const forestTree_15 = new ForestTree1(
      this,
      630,
      57,
      'spring_trees_sheet',
      0,
    );
    this.add.existing(forestTree_15);

    // forestTree_16
    const forestTree_16 = new ForestTree1(
      this,
      733,
      87,
      'spring_trees_sheet',
      0,
    );
    this.add.existing(forestTree_16);

    // forestTree_17
    const forestTree_17 = new ForestTree1(
      this,
      427,
      367,
      'spring_trees_sheet',
      2,
    );
    this.add.existing(forestTree_17);

    // forestTree_18
    const forestTree_18 = new ForestTree1(
      this,
      513,
      362,
      'spring_trees_sheet',
      2,
    );
    this.add.existing(forestTree_18);

    // forestTree_19
    const forestTree_19 = new ForestTree1(
      this,
      55,
      473,
      'spring_trees_sheet',
      2,
    );
    this.add.existing(forestTree_19);

    // forestTree_20
    const forestTree_20 = new ForestTree1(
      this,
      398,
      534,
      'spring_trees_sheet',
      2,
    );
    this.add.existing(forestTree_20);

    // forestTree_21
    const forestTree_21 = new ForestTree1(
      this,
      622,
      494,
      'spring_trees_sheet',
      2,
    );
    this.add.existing(forestTree_21);

    // forestTree_22
    const forestTree_22 = new ForestTree1(
      this,
      767,
      146,
      'spring_trees_sheet',
      2,
    );
    this.add.existing(forestTree_22);

    // forestTree_23
    const forestTree_23 = new ForestTree1(
      this,
      240,
      125,
      'spring_trees_sheet',
      2,
    );
    this.add.existing(forestTree_23);

    // forestTree_24
    const forestTree_24 = new ForestTree1(
      this,
      148,
      54,
      'spring_trees_sheet',
      2,
    );
    this.add.existing(forestTree_24);

    // forestTree_25
    const forestTree_25 = new ForestTree1(
      this,
      26,
      195,
      'spring_trees_sheet',
      2,
    );
    this.add.existing(forestTree_25);

    // worldNode
    const worldNode = new WorldNode(this, 184, 352);
    this.add.existing(worldNode);

    // worldNode_1
    const worldNode_1 = new WorldNode(this, 296, 240);
    this.add.existing(worldNode_1);

    // worldNode_2
    const worldNode_2 = new WorldNode(this, 224, 488);
    this.add.existing(worldNode_2);

    // worldNode_3
    const worldNode_3 = new WorldNode(this, 432, 216);
    this.add.existing(worldNode_3);

    // worldNode_4
    const worldNode_4 = new WorldNode(this, 536, 424);
    this.add.existing(worldNode_4);

    // worldNode_5
    const worldNode_5 = new WorldNode(this, 696, 184);
    this.add.existing(worldNode_5);

    // portal
    const portal = new Portal(this, 728, 232);
    this.add.existing(portal);

    // forestTree_26
    const forestTree_26 = new ForestTree1(this, 48, 352, 'spring 32x', 0);
    this.add.existing(forestTree_26);

    // forestTree_27
    const forestTree_27 = new ForestTree1(this, 304, 352, 'spring 32x', 0);
    this.add.existing(forestTree_27);

    // forestTree_28
    const forestTree_28 = new ForestTree1(this, 352, 496, 'spring 32x', 0);
    this.add.existing(forestTree_28);

    // forestTree_29
    const forestTree_29 = new ForestTree1(this, 480, 32, 'spring 32x', 0);
    this.add.existing(forestTree_29);

    // forestTree_30
    const forestTree_30 = new ForestTree1(this, 528, 48, 'spring 32x', 0);
    this.add.existing(forestTree_30);

    // forestTree_31
    const forestTree_31 = new ForestTree1(this, 560, 32, 'spring 32x', 0);
    this.add.existing(forestTree_31);

    // image_1
    this.add.image(136, 304, 'bonus bridge');

    // image
    this.add.image(352, 272, 'bonus bridge');

    // image_2
    this.add.image(616, 264, 'bonus bridge');

    // mentor
    const mentor = new Mentor2(this, 56, 272);
    this.add.existing(mentor);

    // worldNode_6
    const worldNode_6 = new WorldNode(this, 680, 296);
    this.add.existing(worldNode_6);

    // worldNode_7
    const worldNode_7 = new WorldNode(this, 472, 312);
    this.add.existing(worldNode_7);

    // worldNode_8
    const worldNode_8 = new WorldNode(this, 304, 136);
    this.add.existing(worldNode_8);

    // worldNode_9
    const worldNode_9 = new WorldNode(this, 272, 368);
    this.add.existing(worldNode_9);

    // worldNode (prefab fields)
    worldNode.NPCLevelId = 7;
    worldNode.NPCId = 0;

    // worldNode_1 (prefab fields)
    worldNode_1.NPCLevelId = 7;
    worldNode_1.NPCId = 1;

    // worldNode_2 (prefab fields)
    worldNode_2.NPCLevelId = 7;
    worldNode_2.NPCId = 2;

    // worldNode_3 (prefab fields)
    worldNode_3.NPCLevelId = 7;
    worldNode_3.NPCId = 3;

    // worldNode_4 (prefab fields)
    worldNode_4.NPCLevelId = 7;
    worldNode_4.NPCId = 4;

    // worldNode_5 (prefab fields)
    worldNode_5.NPCLevelId = 7;
    worldNode_5.NPCId = 5;

    // worldNode_6 (prefab fields)
    worldNode_6.NPCLevelId = 7;
    worldNode_6.NPCId = 5;

    // worldNode_7 (prefab fields)
    worldNode_7.NPCLevelId = 7;
    worldNode_7.NPCId = 5;

    // worldNode_8 (prefab fields)
    worldNode_8.NPCLevelId = 7;
    worldNode_8.NPCId = 5;

    // worldNode_9 (prefab fields)
    worldNode_9.NPCLevelId = 7;
    worldNode_9.NPCId = 5;

    this.player = player;
    this.portal = portal;
    this.mentor = mentor;
    this.spring_biome_4 = spring_biome_4;

    this.events.emit('scene-awake');
  }

  private player!: Player;
  private portal!: Portal;
  private mentor!: Mentor2;
  private spring_biome_4!: Phaser.Tilemaps.Tilemap;

  /* START-USER-CODE */

  // Write your code here

  create() {
    this.editorCreate();
    this.initialize({
      camera: this.cameras.main,
      player: this.player,
      tilemap: this.spring_biome_4,
      portal: this.portal,
      mentor: this.mentor,
    });
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
